import Tab from 'bootstrap/js/dist/tab'
import Collapse from 'bootstrap/js/dist/collapse'
import Tooltip from 'bootstrap/js/dist/tooltip'

/**
 * Tooltips
 */
	const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
	const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new Tooltip(tooltipTriggerEl, {
		trigger: 'hover'
	}))


/**
 * Team
 */
	const siteTeam = document.querySelectorAll('[site-team]')

	if (siteTeam.length > 0) {
		siteTeam.forEach(e => {
			e.addEventListener('click', _ => {
				_.preventDefault()
				if (e.classList.contains('is--active')) return;

				const name = e.dataset.name
				const about = e.dataset.about
				const container = document.querySelector('[site-team-detail]')

				if (about) {
					const prevActive = document.querySelector('[site-team].is--active')
					if (prevActive) {
						prevActive.classList.remove('is--active')
						container.classList.remove('show')

						setTimeout(() => {
							container.querySelector('h3').innerHTML = name;
							container.querySelector('p').innerHTML = about.replaceAll(/\n/g, '<br>');
						}, 500);
					} else {
						container.querySelector('h3').innerHTML = name;
						container.querySelector('p').innerHTML = about.replaceAll(/\n/g, '<br>');
					}

					e.classList.add('is--active')

					const tabs = document.querySelector('.about--tabs-list')
					tabs.classList.add('is--closed')
					tabs.querySelector('#about-tab-4').click()

					container.classList.remove('d-none')

					if (prevActive) {
						setTimeout(() => {
							const height = container.querySelector('div').offsetHeight

							container.style.setProperty('--height', `${height}px`)
							container.classList.add('show')
						}, 600)
					} else {
						setTimeout(() => {
							const height = container.querySelector('div').offsetHeight

							container.style.setProperty('--height', `${height}px`)
							container.classList.add('show')
						}, 100)
					}
				}
			})
		})
	}


/**
 * Detact tab open trigger
 */
	const siteAboutTabs = document.querySelectorAll('.about--tabs-list .nav-item button')

	if (siteAboutTabs.length > 0) {
		siteAboutTabs.forEach(e => {
			e.addEventListener('click', _ => {
				const teamActive = document.querySelector('[site-team].is--active')
				if (teamActive) teamActive.classList.remove('is--active')

				document.querySelector('.about--tabs-list').classList.remove('is--closed')

				const details = document.querySelector('[site-team-detail]')
				details.classList.remove('show')

				setTimeout(() => {
					details.classList.add('d-none')
				}, 500)
			})
		})
	}


/**
 * Dismiss
*/
	const resetAboutTabs = () => {
		const mainTab = document.getElementById('about-tab-1-pane')
		if (mainTab && siteAboutTabs.length > 0) {
			if (!mainTab.classList.contains('active')) {
				siteAboutTabs[0].click()
			}
		}
	}

	document.addEventListener('keyup', event => {
		if (event.key === 'Escape') {
			resetAboutTabs();
		}
	}, true)

	const resetAboutButton = document.querySelector('[site-about-dismiss]')

	if (resetAboutButton) {
		resetAboutButton.addEventListener('click', () => resetAboutTabs())
	}


/**
 * Tabs control
 */
	const siteAboutNavTabs = document.querySelectorAll('button[data-bs-toggle="tab"]')

	if (siteAboutNavTabs.length > 0) {
		siteAboutNavTabs.forEach(e => {
			e.addEventListener('shown.bs.tab', event => {
				const currentTab = document.querySelector(event.target.dataset.bsTarget)
				const height = currentTab.querySelector('div').offsetHeight
				const container = currentTab.parentElement

				if (currentTab.id == 'about-tab-4-pane') {
					resetAboutButton.classList.add('is--visible')
				} else {
					resetAboutButton.classList.remove('is--visible')
				}

				container.style.setProperty('--height', `${height}px`)
			})
		})
	}

	window.addEventListener('load', _ => {
		const height = document.querySelector('.tab-pane.show > div')
		const container = document.querySelector('.tab-content')

		if (height && container) container.style.setProperty('--height', `${height.offsetHeight}px`)
	})

	window.addEventListener('resize', _ => {
		setTimeout(() => {
			const height = document.querySelector('.tab-pane.show > div')
			const container = document.querySelector('.tab-content')

			if (height && container) container.style.setProperty('--height', `${height.offsetHeight}px`)
		}, 100)
	})
